const initTabChange = () => {
  const tabButtons = Array.from(document.querySelectorAll('.tab-changer'));
  const sortingTabs = Array.from(document.querySelectorAll('.sorting-option-tab'));
  const categorySelector = document.getElementById('choose-category');
  const searchField = document.getElementById('search-ingredients');

  tabButtons.forEach((tabButton) => {
    tabButton.addEventListener('click', (event) => {
      event.preventDefault();

      document.querySelector('.tab-changer.active').classList.remove('active');
      tabButton.classList.add('active');

      sortingTabs.forEach((sortingTab) => {
        sortingTab.classList.add('hidden');
      });

      categorySelector.selectedIndex = 0;

      if (searchField.value.length > 0) {
        searchField.value = '';
      }

      const { sortingOption } = tabButton.dataset;

      window.history.replaceState(null, null, `?sort=${sortingOption}`);


      document.querySelector(`.${sortingOption}`).classList.remove('hidden');

      const activeLetter = document.querySelector('.alphabet li button.active');
      if (activeLetter) {
        activeLetter.classList.remove('active');
      }

      document.querySelector('.alphabet li button.reset-button').classList.add('active');

      const allItems = Array.from(document.querySelectorAll('.substance-info'));
      allItems.forEach((currentItem) => {
        currentItem.classList.remove('hidden');
      });
    });
  });
};

const initSubstanceFilter = () => {
  const alphabet = Array.from(document.querySelectorAll('ul.alphabet li button'));
  const substanceItems = Array.from(document.querySelectorAll('li.substance-info.ingredient-type'));
  const searchField = document.getElementById('search-ingredients');

  alphabet.forEach((button) => {
    const { letter } = button.dataset;

    if (document.querySelector(`.starts-with-${letter}.ingredient-type`)) {
      button.classList.remove('not-found');
    }

    button.addEventListener('click', (event) => {
      const activeLetter = document.querySelector('.alphabet li button.active');
      if (activeLetter) {
        activeLetter.classList.remove('active');
      }

      button.classList.add('active');

      if (searchField.value.length > 0) {
        searchField.value = '';
      }

      if (letter === 'reset') {
        substanceItems.forEach((item) => {
          item.classList.remove('hidden');
        });

        return;
      }

      substanceItems.forEach((item) => {
        item.classList.add('hidden');
      });

      const currentSubstanceLetter = Array.from(document.querySelectorAll(`.starts-with-${letter}.ingredient-type`));
      currentSubstanceLetter.forEach((currentItem) => {
        currentItem.classList.remove('hidden');
      });

      event.preventDefault();
    });
  });
};

const initCategoryFilter = () => {
  const selector = document.getElementById('choose-category');
  const categoryItems = Array.from(document.querySelectorAll('li.substance-info'));

  selector.addEventListener('change', (event) => {
    event.preventDefault();

    categoryItems.forEach((item) => {
      item.classList.add('hidden');
    });

    const currentChallenge = Array.from(document.querySelectorAll(`.${selector.value}`));
    currentChallenge.forEach((currentItem) => {
      currentItem.classList.remove('hidden');
    });
  });
};

const searchInit = () => {
  const searchField = document.getElementById('search-ingredients');
  const challengeItems = Array.from(document.querySelectorAll('li.substance-info'));
  searchField.addEventListener('input', (event) => {
    event.preventDefault();

    const activeLetter = document.querySelector('.alphabet li button.active');

    if (activeLetter) {
      activeLetter.classList.remove('active');
    }

    if (searchField.value.length > 0) {
      challengeItems.forEach((item) => {
        item.classList.add('hidden');
      });

      const hits = Array.from(document.querySelectorAll(`li.substance-info[data-title*="${searchField.value}" i]`));

      if (hits) {
        hits.forEach((hit) => {
          hit.classList.remove('hidden');
        });
      }
    } else {
      challengeItems.forEach((item) => {
        item.classList.remove('hidden');
        const resetButton = document.querySelector('.alphabet li button.reset-button');
        if (resetButton) {
          resetButton.classList.add('active');
        }
      });
    }
  });
};

const readMoreInit = () => {
  const toggleButtons = Array.from(document.querySelectorAll('ul.substance-info-list a.read-longer-description-toggle'));
  if (toggleButtons) {
    toggleButtons.forEach((button) => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        const id = button.href.split('#')[1];
        if (id) {
          const targetContainer = document.getElementById(id);
          if (targetContainer) {
            targetContainer.classList.remove('hidden');
            button.classList.add('hidden');
          }
        }
      });
    });
  }
};

if (document.body.classList.contains('page-id-2706591')) {
  readMoreInit();
  searchInit();
  initTabChange();
  initSubstanceFilter();
  initCategoryFilter();
}


if (document.body.classList.contains('tax-pa_ingredienser') || document.body.classList.contains('tax-pa_virkestoffer')) {
  const toggleButton = document.querySelector('.read-longer-description-toggle');

  if (toggleButton) {
    toggleButton.addEventListener('click', (event) => {
      event.preventDefault();

      const id = toggleButton.href.split('#')[1];
      if (id) {
        const targetContainer = document.getElementById(id);
        if (targetContainer) {
          targetContainer.classList.remove('hidden');
          toggleButton.classList.add('hidden');
        }
      }
    });
  }
}
